import {
  type PastCommitmentRequestData,
  type RequestData,
  type UpcomingCommitmentRequestData,
} from "~utils";

type RequestPayment =
  | RequestData["payment"]
  | UpcomingCommitmentRequestData["payment"]
  | PastCommitmentRequestData["payment"];

export const getBonusDetails = (payment: RequestPayment) => {
  const { hourlyPayValue } = payment ?? {};

  const bonus = payment?.bonuses?.at(0);
  const hasRequestBonus = Boolean((bonus && bonus?.amount) || bonus?.percentage);
  const bonusText = bonus?.amount
    ? `$${bonus.amount / 100}`
    : bonus?.percentage
      ? `${bonus.percentage / 100}%`
      : null;

  const bonusHourlyPay =
    hourlyPayValue && hourlyPayValue > 0 && bonus?.percentage
      ? hourlyPayValue + Math.floor((hourlyPayValue * bonus.percentage) / 10000)
      : hourlyPayValue;

  return {
    hasRequestBonus,
    bonusText,
    bonusHourlyPay,
  };
};
